import { FC } from 'react';
import { Empty } from 'antd';
import classnames from 'classnames';

import { SkeletonComponent } from '../Skeleton';

import { useTranslate } from 'hooks';

import s from './index.module.scss';

type TableWrapperProps = {
	data: any[];
	children: JSX.Element;
	loading: boolean;
};

export const TableWrapper: FC<TableWrapperProps> = ({ data, children, loading }) => {
	const { noDataText } = useTranslate(['noDataText']);
	return (
		<div className={classnames({ [s.skeleton]: loading })}>
			<SkeletonComponent loading={loading}>
				{data.length > 0 ? (
					children
				) : (
					<Empty
						image={Empty.PRESENTED_IMAGE_SIMPLE}
						className={s.empty}
						description={noDataText}
					/>
				)}
			</SkeletonComponent>
		</div>
	);
};
